(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-whats-inside-v3"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.m-whats-inside-v3-show-more').forEach((btn) => {
    const grid = document.getElementById(btn.getAttribute('aria-controls'));
    if (!grid) return;
    const moreLabel = btn.dataset.showMore;
    const lessLabel = btn.dataset.showLess;
    btn.addEventListener('click', () => {
      const expanded = grid.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', String(expanded));
      btn.textContent = expanded ? lessLabel : moreLabel;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md_footer"]) return;
  try {
    
(function () {
  function initFooterAccordion(root) {
    var footer = root.querySelector
      ? root.querySelector('#shopify-section-md_footer')
      : null;

    if (!footer && root.id === 'shopify-section-md_footer') {
      footer = root;
    }

    if (!footer) return;

    var menuContainers = footer.querySelectorAll(
      '.Mobile_only .md_footer_menu_cont'
    );

    menuContainers.forEach(function (menu, index) {
      var title = menu.querySelector('.md_accordion_title');
      var content = menu.querySelector('.md_footer_menu_content');

      if (!title || !content || title.dataset.accordionReady === 'true') {
        return;
      }

      var contentId = 'FooterMenuContent-' + index;
      content.id = contentId;
      title.dataset.accordionReady = 'true';
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-controls', contentId);
      title.setAttribute('aria-expanded', 'false');

      function toggleMenu() {
        var isOpen = menu.classList.toggle('is-open');
        title.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      title.addEventListener('click', toggleMenu);

      title.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleMenu();
        }
      });
    });
  }

  function startFooterAccordion() {
    initFooterAccordion(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startFooterAccordion);
  } else {
    startFooterAccordion();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFooterAccordion(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
